<template>
  <div id="login" :style="{ backgroundImage: `url(${meta.bg})`, backgroundSize: 'cover', backgroundPosition: 'center' }">
    <logo large class="mg" />

    <div id="loginInfo">

      <div @click="goToReg" class="title-btn">
        {{ $t('login["Register"]') }}
      </div>

      <div id="loginTitle">
        {{ $t('login["Log in to your"]') }}<span style="font-size: 28px;color:#FF5E00 ">{{ $t('login["Account"]') }}</span>
      </div>

      <div style="display: flex;flex-direction: column;padding: 0 21px;">
        <input :placeholder="$t('login[\'Please enter your email address\']')"
               type="text" id="emailAddress" v-model="form.email">
        <input v-if="loginSwitch.type" :placeholder="$t('login[\'Please enter your password\']')"
               type="password" id="pwd" v-model="form.password">
        <div class="form-input-code" v-else>
          <input :placeholder="$t('login[\'Enter code\']')"
                 type="text" class="ipt-code" v-model="form.code">
          <button class="loginBtn getCode" @click="sendEmailCode">{{ loginSwitch.getCodeButtonLabel }}</button>
        </div>
      </div>

      <div v-if="loginSwitch.type" style="text-align: right;padding:12px 20px 24px 20px;cursor: pointer">
        <span @click="goToForgetPwd" style="font-size: 18px;color: #4A4D51 ">{{ this.$t('login["Forget Password"]') }}</span>
        <img src="../../views/login/images/q.png" alt="">
      </div>

      <div class="privacy-agreement-checkbox-wrap">
        <PrivacyAgreementCheckBox v-model="readInfo" />
      </div>
      <div style="padding: 0 20px">
        <div class="loginBtn" @click="doLogin">
          {{ this.$t('login["Log In"]') }}
        </div>
      </div>

      <div style="text-align: center;padding:12px 20px 24px 20px">
        <span @click="loginSwitch.type=!loginSwitch.type"
              style="font-size: .9rem;color: #4A4D51 ">{{ loginSwitch[loginSwitch.type].buttonLabel }}</span>
        <img src="../../views/login/images/arr.png" alt="">
      </div>
    </div>

    <custom-dialog
      v-model="showDialog"
      width="500"
      confirmText="OK"
      cancelType="primary"
      :confirmBtnLoading="confirmBtnLoading"
      :title="$t('base.notice')"
    >
      <div>
        {{ confirmInfo }}
      </div>
    </custom-dialog>

    <custom-dialog
      v-model="showDialog2"
      width="500"
      confirmText="OK"
      cancelType="primary"
      :confirmBtnLoading="confirmBtnLoading2"
      @confirm="confirmModel2"
      @change="changeModel2"
      :title="dialog2Title"
    >
      <div>
        {{ confirmInfo2 }}
      </div>
    </custom-dialog>
  </div>
</template>

<script>

import axios from "../../utils/request";
import CustomDialog from "../../components/alert.vue";
import meta from "../../utils/meta";
import Vue from 'vue'
import PrivacyAgreementCheckBox from "../../components/PrivacyAgreementCheckBox.vue";

export default {
  name: 'login',
  components: {PrivacyAgreementCheckBox, CustomDialog},
  data() {
    return {
      dialog2Title: this.$t('base.notice'),
      confirmBtnLoading2: '',
      confirmInfo2: '',
      showDialog2: false,
      readInfo: false,
      confirmBtnLoading: '',
      confirmInfo: '',
      showDialog: false,
      form: {
        email: '',
        password: '',
        code: ''
      },
      sendingEmail: false,
      meta,
      loginSwitch: {
        type: true,
        true: {
          buttonLabel: this.$t('login[\'Login with code\']'),
          url: '/login',
          msg: this.$t('login[\'Please input email and password\']')
        },
        false: {
          buttonLabel: this.$t('login[\'Login with password\']'),
          url: '/emailLogin',
          msg: this.$t('login[\'Please input email and code\']')
        },
        getCodeButtonLabel: this.$t('login[\'Get code\']')
      }
    }
  },
  methods: {
    goToForgetPwd(){
      this.$router.push('/forget_pwd')
    },
    changeModel2() {
      this.showDialog2 = false
    },
    confirmModel2() {
      this.dialog2Title = this.$t('base.notice')
      this.showDialog2 = false
    },
    goToReg() {
      this.$router.push('/reg')
    },
    sendEmailCode() {
      if (this.loginSwitch.getCodeButtonLabel !== this.$t('login[\'Get code\']')) {
        return
      }
      if (!this.form.email) {
        this.showDialog2 = true
        this.confirmInfo2 = this.$t('login[\'Please enter email address\']')
        return
      }
      if (this.sendingEmail) {
        return
      }
      this.sendingEmail = true
      axios({
        method: 'post',
        url: '/businese/user_info/sendLoginCode?email=' + encodeURIComponent(this.form.email),
        timeout: 60000
      }).then(({ code, msg }) => {
        if (code === 200) {
          this.loginSwitch.getCodeButtonLabel = 60
          const interval = setInterval(() => {
            this.loginSwitch.getCodeButtonLabel--
            if (this.loginSwitch.getCodeButtonLabel == '0') {
              this.loginSwitch.getCodeButtonLabel = this.$t('login[\'Get code\']')
              clearInterval(interval)
            }
          }, 1000)
          this.confirmInfo2 = this.$t('login[\'Email sent successfully\']')
        } else {
          this.confirmInfo2 = msg || this.$t('login[\'Email send failed\']')
        }
        this.showDialog2 = true
      }).catch(() => {
        this.confirmInfo2 = this.$t('login[\'Cannot connect to server\']')
        this.showDialog2 = true
      }).finally(() => this.sendingEmail = false)
    },
    doLogin() {
      if (!(this.form.email.trim() && (this.form.password || this.form.code))) {
        this.showDialog2 = true
        this.confirmInfo2 = this.loginSwitch[this.loginSwitch.type].msg
        return
      }
      if (this.readInfo) {
        axios({
          method: "post",
          url: this.loginSwitch[this.loginSwitch.type].url,
          data: this.form
        }).then(({ code, msg }) => {
          if (code === 200) {

            // 获取用户信息
            meta.fetchLoginUserData().then(() => {
              this.$router.push('/person_center')
            }).catch(() => {
              this.showDialog2 = true
              this.confirmInfo2 = this.$t('login[\'fetching user data error\']')
            })

          } else {
            this.showDialog2 = true
            this.confirmInfo2 = msg
          }
        })
      } else {
        this.showDialog2 = true
        this.confirmInfo2 = this.$t('login[\'Please agree to the agreement\']')
      }

    }
  }
}
</script>

<style scoped>
#login {
  width: 100%;
 min-height: 100vh;
  background-size: cover;
  text-align: center;
  position: relative;
  background-attachment: fixed;
  z-index: 1;
}

#loginInfo {
  background: linear-gradient(180deg, #FFFFFF 0%, #F7FEF1 100%);
  box-shadow: 0 7px 13px 0 rgba(5, 78, 171, 0.33);
  margin-left: 20px;
  margin-right: 20px;
  border-radius: 25px;
  padding-bottom: 20px;
  position: relative;
  z-index: 9;
}

#emailAddress {
  height: 52px;
  border-radius: 16px;
  margin-bottom: 16px;
  padding: 0 15px;
  border: 1px solid #C8C8C8;
}

#pwd,.ipt-code {
  height: 52px;
  border-radius: 16px;
  padding: 0 15px;
  border: 1px solid #C8C8C8;
  min-width: 0;
}

#loginTitle {
  height: 40px;
  font-weight: 600;
  font-size: 18px;
  color: #000000;
  line-height: 40px;
  text-align: left;
  font-style: normal;
  padding-left: 21px;
  padding-top: 27px;
  padding-bottom: 26px;
  letter-spacing: -.04rem;
  white-space: nowrap;
}

.form-input-code {
  display: flex;
  gap: 15px;
  margin-bottom: 30px;
}

.ipt-code {
  flex: 1 1 auto;
}

.loginBtn {
  height: 58px;
  background: linear-gradient(133deg, #F8B029 0%, #F6923D 100%);
  border-radius: 20px;
  padding: 0 20px;

  font-weight: 600;
  font-size: 20px;
  color: #FFFFFF;
  line-height: 58px;
  text-align: center;
  font-style: normal;
  cursor: pointer;
}

.getCode {
  line-height: 1;
  height: unset;
  border-radius: 16px;
  font-size: unset;
  border: none;
  width: 109px;
  flex: 0 0 109px;
}

.privacy-agreement-checkbox-wrap {
  padding: 0 20px;
}

.mg {
  padding: 10vw 0;
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue